module.exports = __webpack_public_path__ + "img/bell-selected.53321775.png";